import apiFetch from '../apiFetch'

export default function (token, fleetDocumentDetails, fleetId, documentTypeUseId, documentTypeEntityId) {
  const queryParamsArray = [
    fleetId ? `fleetId=${fleetId}` : null,
    documentTypeUseId ? `documentTypeUseId=${documentTypeUseId}` : null,
    documentTypeEntityId ? `documentTypeEntityId=${documentTypeEntityId}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `UnattendedProcess/SetGenerateUploadDocumentFleet${queryParams}`, method: 'POST', body: fleetDocumentDetails, token: token })
}
